import { AuthResponse, LoginInput } from '../../lib/types/models/auth/login'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function login(data: LoginInput) {
  return restApiClient
    .url(constructApiUrl(API.auth.login.url, null))
    .post<AuthResponse, LoginInput>(data)
}
